const EN_TRANSLATE = {
    multilang_example: "Multi Lang Example"
}

export default EN_TRANSLATE;
